// extracted by mini-css-extract-plugin
export default {"shadowed":"Navbar_shadowed__nJ8J0","active":"Navbar_active__Qwlvp"};